var render, staticRenderFns
import script from "./CenterButton.vue?vue&type=script&lang=js&"
export * from "./CenterButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CenterButton.vue"
export default component.exports